import api from './index'
import type { ApiResponse } from '@/types'

export interface AttachmentWithDetails {
  id: string
  originalName: string
  filename: string
  filepath: string
  size: number
  mimeType: string
  uploadedById: string
  issueId?: string
  commentId?: string
  createdAt: string
  updatedAt: string
  uploadedBy: {
    id: string
    name: string
    email: string
    avatar?: string
  }
  issue?: {
    id: string
    key: string
    title: string
  }
  comment?: {
    id: string
    content: string
  }
}

export interface AttachmentFilters {
  search?: string
  uploaderId?: string
  fileType?: 'image' | 'video' | 'document'
  startDate?: string
  endDate?: string
  page?: number
  limit?: number
}

export interface AttachmentListResponse {
  attachments: AttachmentWithDetails[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
}

export interface UploaderInfo {
  id: string
  name: string
  email: string
  avatar?: string
}

export interface AttachmentStats {
  total: number
  byType: {
    image: number
    video: number
    document: number
  }
  totalSize: number
}

export const getProjectAttachments = async (
  projectKey: string,
  filters: AttachmentFilters = {}
): Promise<ApiResponse<AttachmentListResponse>> => {
  const params = new URLSearchParams()
  
  if (filters.search) params.append('search', filters.search)
  if (filters.uploaderId) params.append('uploaderId', filters.uploaderId)
  if (filters.fileType) params.append('fileType', filters.fileType)
  if (filters.startDate) params.append('startDate', filters.startDate)
  if (filters.endDate) params.append('endDate', filters.endDate)
  if (filters.page) params.append('page', filters.page.toString())
  if (filters.limit) params.append('limit', filters.limit.toString())

  const response = await api.get(`/projects/${projectKey}/attachments?${params}`)
  return response.data
}

export const getProjectUploaders = async (
  projectKey: string
): Promise<ApiResponse<{ uploaders: UploaderInfo[] }>> => {
  const response = await api.get(`/projects/${projectKey}/attachments/uploaders`)
  return response.data
}

export const getAttachmentStats = async (
  projectKey: string
): Promise<ApiResponse<{ stats: AttachmentStats }>> => {
  const response = await api.get(`/projects/${projectKey}/attachments/stats`)
  return response.data
}

export const downloadAttachment = async (attachmentId: string, filename: string): Promise<void> => {
  try {
    console.log('正在下載附件:', attachmentId)
    console.log('認證 token:', localStorage.getItem('auth_token') ? '存在' : '不存在')
    
    const response = await api.get(`/download/${attachmentId}`, {
      responseType: 'blob'
    })

    console.log('下載響應:', response.status)

    // 創建下載連結
    const blob = new Blob([response.data])
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error: any) {
    console.error('下載附件失敗:', error)
    console.error('錯誤詳情:', error.response?.data)
    console.error('錯誤狀態:', error.response?.status)
    const errorMessage = error.response?.data?.error || error.message || '下載失敗'
    throw new Error(errorMessage)
  }
}